<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 16 15">
    <g clip-path="url(#clip0_6892_9108)">
      <path
        d="M0.777832 0V15L15.7778 7.46127L0.777832 0ZM2.06871 2.09122L12.8863 7.47418L2.06871 12.9088V2.09122Z"
        :class="colorClass"
      />
    </g>
    <defs>
      <clipPath id="clip0_6892_9108">
        <rect width="15" height="15" fill="white" transform="translate(0.777832)" />
      </clipPath>
    </defs>
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
